import { Floor, Transform } from '../../SavaneJS';
import { GeometryGroup } from '../GeometryPrimitives/GeometryGroup';
import { TemporaryEntity } from './TemporaryEntity';

/**
 * TemporaryGeometryGroup is used for GeometryGroup edition
 */
export class TemporaryGeometryGroup extends TemporaryEntity {

    private _transform: Transform;

    constructor(geometryGroup: GeometryGroup) {
        super(geometryGroup);

        this._transform = new Transform(null);
        this._transform.clone(geometryGroup.transform);
    }

    computeValidity(floor: Floor) {
        this._isValid = true;
    }

    get transform(): Transform {
        return this._transform;
    }
}
